import {Accordion, AccordionSummary, Stack, styled} from '@mui/material';

const StyledAccordion = styled(Accordion)`
	&.MuiAccordion-root {
		box-shadow: none;
		border-top: 0px;

		::before {
			background-color: transparent;
		}

		border-radius: 8px;
	}
`;

const StyledAccordionSummary = styled(AccordionSummary)`
	&.MuiAccordionSummary-root {
		border-top: 0px;
	}

	.MuiAccordionSummary-content {
		margin: 0px;
		padding: 16px 0;
	}
`;

const StyledStack = styled(Stack)`
	background-color: ${({theme}) => theme.colors.light.info['190Percent']};
	padding: 12px 16px;
	border-radius: 0 0 8px 8px;
`;

export {StyledAccordion, StyledAccordionSummary, StyledStack};
